// export const BASE_URL = "http://localhost:5000";
// export const SCRAPING_BASE_URL = process.env.REACT_APP_SCRAPING_API || "http://localhost:8000";
export const BASE_URL = "/api";
export const SCRAPING_BASE_URL =process.env.REACT_APP_SCRAPING_API || "/scraping";